import EPGCategoryChannels from './EPGCategoryChannels';

export * from './EPGCategoryChannels';

export default EPGCategoryChannels;
